var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('Header'),_c('ShareBar'),_vm._m(0),_c('Footer')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('main',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"content-space"}),_c('div',{staticClass:"content-wrapper normal"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"title"},[_vm._v("重要告示")])])]),_c('div',{staticClass:"content-space"})])])
}]

export { render, staticRenderFns }